module.exports = __webpack_public_path__ + "static/media/LandingPage-pic01.f88e243f.png";